import { loc } from "../i18n/survey";

enum Age {
  Teens = "< 20",
  Twenties = "20-29",
  Thirties = "30-39",
  Fourties = "40-49",
  OverFifty = "50+",
}


const ageQuestion = {
  name: "age",
  description: loc("quiz.age.description"),
  descriptionLocation: "underTitle",
  title: loc("quiz.age.title"),
  type: "radiogroup",
  choices: Object.values(Age).map((value) => ({ value, text: loc(`quiz.age.choices.${value}`) })),
  isRequired: true,
};

export { Age, ageQuestion };
